/* MILLO GANG · home (tema de Shopify). Migración 12-oct-2026: los scripts de index.html de la web de trabajo, tal cual y en el mismo orden.
   Se carga desde la sección mg-home-hero (defer). Si layout/theme.liquid también lo carga, la segunda vez no hace nada. */
(function(){
if (window.__mgHomeJs) return; window.__mgHomeJs = 1;
var mgHomeEn = /^en(?:-|$)/i.test(document.documentElement.lang || '');

/* ── Tienda: entrada al llegar (y barra de avance si la hay) ── */
(function(){
  var sec=document.getElementById('tienda'); if(!sec) return;
  var rail=sec.querySelector('[data-hm-rail]');
  var calm=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(!calm){
    var shown=false, show=function(){ if(shown) return; shown=true; sec.classList.add('hms-in'); window.removeEventListener('scroll',chk); };
    var chk=function(){ var r=sec.getBoundingClientRect(); if(r.top < innerHeight*.75 && r.bottom > 0) show(); };
    var rTop=sec.getBoundingClientRect().top;
    if(rTop > innerHeight*.75){ sec.classList.add('hms-pre'); window.addEventListener('scroll',chk,{passive:true}); setTimeout(function(){ if(!shown && sec.getBoundingClientRect().top < innerHeight) show(); },2500); }
  }
  var pb=sec.querySelector('.hms-prog__bar span'), pn=sec.querySelector('.hms-prog__n b'), pt=sec.querySelector('.hms-prog__n i');
  var prog=function(){ var items=[].filter.call(rail.querySelectorAll('[data-cat]'),function(e){return e.offsetParent!==null && !e.classList.contains('off');}); var max=rail.scrollWidth-rail.clientWidth, f=max>0?rail.scrollLeft/max:1; pb.style.transform='scaleX('+Math.max(.06,f).toFixed(3)+')'; var i=0,rl=rail.getBoundingClientRect().left; items.forEach(function(e,k){ if(e.getBoundingClientRect().left-rl < 40) i=k; }); pn.textContent=String(Math.min(items.length,i+1)).padStart(2,'0'); pt.textContent=String(items.length).padStart(2,'0'); };
  var progFrame=0;
  function queueProg(){if(progFrame)return;progFrame=requestAnimationFrame(function(){progFrame=0;prog();});}
  if(pb){ rail.addEventListener('scroll',queueProg,{passive:true}); window.addEventListener('resize',queueProg); sec.addEventListener('click',function(){ setTimeout(queueProg,450); }); prog(); }

})();

/* ── Club: el carnet se inclina con el ratón ── */
  (function(){
    var st=document.querySelector('[data-hmx-tilt]'); if(!st||!matchMedia('(hover:hover) and (pointer:fine)').matches||matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    var sec=st.closest('section'),tx=0,ty=0,cx=0,cy=0,raf=0;
    function loop(){cx+=(tx-cx)*.08;cy+=(ty-cy)*.08;st.style.setProperty('--rx',(-cy*14).toFixed(2)+'deg');st.style.setProperty('--ry',(cx*18).toFixed(2)+'deg');st.style.setProperty('--gx',(50+cx*40).toFixed(1)+'%');st.style.setProperty('--gy',(50+cy*40).toFixed(1)+'%');raf=(Math.abs(tx-cx)+Math.abs(ty-cy)>.001)?requestAnimationFrame(loop):0;}
    sec.addEventListener('pointermove',function(e){var r=st.getBoundingClientRect();tx=Math.max(-1,Math.min(1,(e.clientX-r.left-r.width/2)/(r.width/2)));ty=Math.max(-1,Math.min(1,(e.clientY-r.top-r.height/2)/(r.height/2)));if(!raf)raf=requestAnimationFrame(loop);});
    sec.addEventListener('pointerleave',function(){tx=0;ty=0;if(!raf)raf=requestAnimationFrame(loop);});
  })();
  

/* ── Colecciones (.mx-a) ── */
  /* MX-A · colecciones: abre el panel con el ratón, el foco o el primer toque; ajusta el título al ancho; aparición al llegar */
  (function(){
    var s = document.querySelector('.mx-a'); if (!s) return;
    var ps = [].slice.call(s.querySelectorAll('.mx-a__p'));
    var desk = window.matchMedia('(min-width: 1024px)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var vid = s.querySelector('video');
    var cur = -1, t = 0, ptr = false, seen = false;
    s.classList.add('mx-a--js');

    function set(i, scroll){
      if (i === cur) return; cur = i;
      ps.forEach(function(p, k){
        var on = k === i, b = p.querySelector('.mx-a__b');
        p.classList.toggle('is-on', on);
        if (b) { if (on) b.removeAttribute('inert'); else b.setAttribute('inert', ''); }
      });
      if (scroll && !desk.matches) {
        var p = ps[i];
        setTimeout(function(){
          var r = p.getBoundingClientRect(), hd = document.querySelector('.hd'), top = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 72;
          if (Math.abs(r.top - top) > 4 && (r.top < top || r.top > window.innerHeight * .4)) window.scrollTo({ top: r.top + window.scrollY - top, behavior: calm.matches ? 'auto' : 'smooth' });
        }, calm.matches ? 0 : 720);
      }
    }
    ps.forEach(function(p, i){
      p.addEventListener('pointerenter', function(e){
        if (!desk.matches || e.pointerType !== 'mouse') return;
        clearTimeout(t); t = setTimeout(function(){ set(i); }, 90);
      });
      p.addEventListener('pointerleave', function(){ clearTimeout(t); p.style.removeProperty('--px'); p.style.removeProperty('--py'); });
      /* la foto del panel abierto sigue un poco al cursor */
      p.addEventListener('pointermove', function(e){
        if (!desk.matches || !fine.matches || calm.matches || cur !== i) return;
        var r = p.getBoundingClientRect();
        p.style.setProperty('--px', ((e.clientX - r.left) / r.width * 2 - 1).toFixed(3));
        p.style.setProperty('--py', ((e.clientY - r.top) / r.height * 2 - 1).toFixed(3));
      });
      /* con teclado, el foco abre el panel; con el dedo, el primer toque abre y el segundo entra en la colección */
      p.addEventListener('pointerdown', function(){ ptr = true; setTimeout(function(){ ptr = false; }, 700); });
      p.addEventListener('focusin', function(){ if (!ptr) set(i); });
      var hit = p.querySelector('.mx-a__hit');
      hit.addEventListener('click', function(e){ if (cur !== i) { e.preventDefault(); set(i, true); } });
    });
    set(0);

    /* el título abierto ocupa justo el ancho del panel; en escritorio crece con el panel mientras se abre (--ku) y nunca se sale */
    function fit(){
      var res = [], dk = desk.matches, pad = dk ? 0 : 48, row = s.querySelector('.mx-a__ps'), n = ps.length;
      var sc = getComputedStyle(s), gap = parseFloat(sc.getPropertyValue('--gap')) || 3, g = parseFloat(sc.getPropertyValue('--g')) || 5.2;
      var mp = parseFloat(getComputedStyle(ps[0].querySelector('.mx-a__b')).left) || 0;
      /* ancho fijo del texto del panel abierto: no cambia mientras el panel se abre, así no se recoloca */
      if (dk && row) s.style.setProperty('--bw', ((row.clientWidth - gap * (n - 1)) * g / (g + n - 1) - mp * 2).toFixed(1) + 'px');
      else s.style.removeProperty('--bw');
      ps.forEach(function(p){
        var tt = p.querySelector('.mx-a__t span'), b = p.querySelector('.mx-a__b'); if (!tt || !b) return;
        var cs = getComputedStyle(b), w = b.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        tt.style.transition = 'none'; tt.style.fontSize = '100px';
        var u = tt.getBoundingClientRect().width / 100;
        tt.style.fontSize = '';
        res.push([tt, w * .985 / u, (w - pad) * .985 / u, .985 / u]);
      });
      var max = dk ? Math.min(128, window.innerHeight * .118) : 64;
      /* en móvil las franjas cerradas miden lo mismo (todas al tamaño del título más largo) y el panel abierto llena el ancho */
      var same = Math.min.apply(null, res.map(function(r){ return r[2]; }));
      res.forEach(function(r){
        var o = Math.max(30, Math.min(max, r[1])), c = dk ? o : Math.max(30, Math.min(max, same));
        r[0].style.setProperty('--fs-o', o.toFixed(1) + 'px'); r[0].style.setProperty('--fs-c', c.toFixed(1) + 'px'); r[0].style.setProperty('--ku', r[3].toFixed(4));
        void r[0].offsetWidth; r[0].style.transition = '';
      });
      /* palabras verticales: todas iguales y dentro del panel cerrado (alto libre bajo «Colecciones.» y ancho de la franja) */
      var vs = [].slice.call(s.querySelectorAll('.mx-a__v b')), top = s.querySelector('.mx-a__top');
      if (dk && vs.length) {
        var sr = s.getBoundingClientRect(), v0 = vs[0].parentNode, bot = parseFloat(getComputedStyle(v0).bottom) || 44;
        var freeH = s.clientHeight - bot - (top ? top.getBoundingClientRect().bottom - sr.top : 84) - 28;
        var closedW = (row.clientWidth - gap * (n - 1)) / (g + n - 1);
        var um = 0;
        vs.forEach(function(b){ b.style.fontSize = '100px'; um = Math.max(um, b.getBoundingClientRect().height / 100); b.style.fontSize = ''; });
        var cap = Math.min(72, window.innerWidth * .046, window.innerHeight * .08);
        var fv = Math.min(cap, freeH / um, (closedW - mp - 34) / 1.04);
        s.style.setProperty('--fs-v', Math.max(24, fv).toFixed(1) + 'px');
      } else s.style.removeProperty('--fs-v');
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var rt = 0; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(fit, 120); });

    /* aparición y vídeo: en cuanto asoma el primer píxel (las fotos ya están a la vista; solo se asientan) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !seen) { seen = true; s.classList.add('is-in'); }
          if (vid) { if (e.isIntersecting && !calm.matches) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function(){}); } else vid.pause(); }
        });
      }, { threshold: 0 }).observe(s);
    } else { s.classList.add('is-in'); }
    if (vid && calm.matches) { vid.addEventListener('loadedmetadata', function(){ try { vid.currentTime = 1.5; } catch(e){} }); }
  })();

/* ── Instagram ── */
/* Instagram: entrada escalonada, paralaje por columna, barra de progreso y vídeos solo en pantalla (todo fuera con «reducir movimiento») */
(function(){
var g=document.querySelector("[data-hm-ig-grid]");if(!g)return;var ts=[].slice.call(g.querySelectorAll("[data-hm-ig-t]")),vs=[].slice.call(g.querySelectorAll("[data-hm-ig-v]"));
var calm=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
if(calm){g.classList.add("is-in");vs.forEach(function(v){v.removeAttribute("autoplay");v.pause();});return;}
g.classList.add("hm-ig--fx");ts.forEach(function(t,i){t.style.setProperty("--d",(i*110)+"ms");});
vs.forEach(function(v){var bar=v.closest("[data-hm-ig-t]").querySelector(".hm-ig__bar i");if(bar)v.addEventListener("timeupdate",function(){if(v.duration)bar.style.transform="scaleX("+(v.currentTime/v.duration).toFixed(3)+")";});});
var SP={"hm-ig__t--a":.05,"hm-ig__t--b":-.04,"hm-ig__t--c":-.04,"hm-ig__t--d":.09},raf=0,playing=null;
function play(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}
function tick(){raf=0;var r=g.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight,on=r.bottom>0&&r.top<vh;
 if(on&&r.top<vh*.88)g.classList.add("is-in");
 if(on!==playing){playing=on;vs.forEach(function(v){if(on)play(v);else v.pause();});}
 var desk=window.innerWidth>1023,c=(r.top+r.height/2)-vh/2;
 ts.forEach(function(t){if(!on||!desk){t.style.removeProperty("--py");return;}var k=0;for(var n in SP)if(t.classList.contains(n))k=SP[n];t.style.setProperty("--py",(-c*k).toFixed(1)+"px");});}
function req(){if(raf)return;raf=1;(window.requestAnimationFrame||setTimeout)(tick);setTimeout(function(){if(raf)tick();},120);}
window.addEventListener("scroll",req,{passive:true});window.addEventListener("resize",req);document.addEventListener("visibilitychange",function(){if(document.hidden)vs.forEach(function(v){v.pause();});else{playing=null;req();}});tick();
})();

/* ── Portada, tienda, talla rápida y vídeos ── */
  /* Home C+B · portada, tienda, talla rápida y vídeos (sin librerías) */
  (function(){
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function $(s, r){ return (r || document).querySelector(s); }
    function $$(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
    function play(v){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }

    /* ── portada: el anuncio ya viene recortado en el archivo (sin las manos del principio ni el cierre en negro) y se repite con el loop del propio vídeo ── */
    var hv = $('[data-hm-hero]'), pb = $('[data-hm-pause]'), paused = calm;
    if (hv) {
      var setBtn = function(){ if (!pb) return; pb.setAttribute('aria-pressed', String(paused)); pb.querySelector('span').textContent = paused ? (mgHomeEn ? 'Play video' : 'Ver vídeo') : (mgHomeEn ? 'Pause video' : 'Pausar vídeo');
        pb.querySelector('svg').innerHTML = paused ? '<path d="M2 1l7 4-7 4z" fill="currentColor"/>' : '<path d="M2 1v8M8 1v8" stroke="currentColor" stroke-width="1.6"/>'; };
      if (pb) pb.addEventListener('click', function(){ paused = !paused; if (paused) hv.pause(); else play(hv); setBtn(); });
      setBtn();
      if (paused) { hv.removeAttribute('autoplay'); hv.pause(); } else play(hv);
      if (!paused) hv.addEventListener('loadeddata', function(){ if (hv.paused) play(hv); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(e){ if (paused) return; if (e.isIntersecting) play(hv); else hv.pause(); }); }, { threshold: .05 }).observe(hv);
    }

    /* Reintento por gesto para iOS/Instagram: solo los vídeos visibles. Los de fuera de pantalla
       conservan su carga diferida; su observer y un gesto cuando entren vuelven a intentar play(). */
    if (!calm) (function(){
      var EV = ['touchend', 'click', 'keydown'];
      function kick(){
        var vh = innerHeight || document.documentElement.clientHeight;
        $$('video').forEach(function(v){
          if (!v.muted || !v.paused) return;
          if (v === hv && paused) return;
          var r = v.getBoundingClientRect(), on = r.width > 0 && r.bottom > 0 && r.top < vh;
          if (!on) return;
          var p = v.play();
          if (p && p.catch) p.catch(function(){});
        });
      }
      EV.forEach(function(n){ addEventListener(n, kick, { capture: true, passive: true }); });
    })();

    /* «MILLO GANG»: en móvil ocupa el ancho; en escritorio va discreto, abajo en el centro, en la línea del botón y las miniaturas */
    var nm = $('[data-hm-fit]');
    function fit(){
      if (!nm) return;
      var box = nm.parentNode, hero = nm.closest('.hm-hero'), cs = getComputedStyle(box), w = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), fs;
      if (window.innerWidth <= 760) {
        nm.style.setProperty('--fs', '100px');
        var r = document.createRange(); r.selectNodeContents(nm); var tw = r.getBoundingClientRect().width || nm.scrollWidth;
        fs = Math.min(100 * w / tw * .995, 140);
        if (hero) hero.classList.remove('hm-hero--fila');
      } else {
        /* todas las variantes van al mismo cuerpo: la más larga («MILLO GANTEL CLUB») tiene que caber entre el botón y las miniaturas */
        var pr = document.createElement('span'); pr.className = 'hm-hero__name'; pr.textContent = 'Millo Gantel Club';
        pr.style.cssText = 'position:absolute;left:-9999px;top:0;display:inline-block;visibility:hidden;font-size:100px';
        document.body.appendChild(pr); var lw = pr.getBoundingClientRect().width || 1300; document.body.removeChild(pr);
        var side = 0; [box.querySelector('.hm-hero__btns .btn'), box.querySelector('.hm-hero__drop')].forEach(function(el){ if (el) side = Math.max(side, el.getBoundingClientRect().width); });
        var cap = Math.min(window.innerHeight * .07, 84);
        fs = Math.min(100 * (w - 2 * side - 72) / lw, cap);
        var fila = fs >= 34;                  /* si no cabe en la fila (tableta), va justo encima, igual de discreto */
        if (!fila) fs = Math.min(100 * w * .7 / lw, cap);
        if (hero) hero.classList.toggle('hm-hero--fila', fila);
      }
      nm.style.setProperty('--fs', fs.toFixed(1) + 'px');
      if (hero) hero.style.setProperty('--fs', fs.toFixed(1) + 'px');
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var rt = 0; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(fit, 100); });

    /* ── tienda: filtros, flechas y aviso para lectores de pantalla ── */
    var shop = $('#tienda');
    if (shop) {
      var rail = $('[data-hm-rail]', shop), live = $('[data-hm-live]', shop), prev = $('[data-hm-prev]', shop), next = $('[data-hm-next]', shop),
          tabs = $$('.hm-shop__tabs button', shop), cards = $$('[data-cat]', rail), cur = 'all',
          NAMES = mgHomeEn ? { all: ['piece', 'pieces'], sudaderas: ['hoodie', 'hoodies'], camisetas: ['T-shirt', 'T-shirts'], pantalones: ['pair of pants', 'pairs of pants'], accesorios: ['accessory, coming soon', 'accessories, coming soon'] } : { all: ['pieza', 'piezas'], sudaderas: ['sudadera', 'sudaderas'], camisetas: ['camiseta', 'camisetas'], pantalones: ['pantalón', 'pantalones'], accesorios: ['accesorio, próximamente', 'accesorios, próximamente'] };
      /* ancho de tarjeta: en escritorio, las fotos llenan el alto de la fila (sin franja vacía debajo) y asoma entre un 20 y un 80 % de la siguiente; en tableta, las que quepan enteras y un 40 % */
      var size = function(){
        if (window.innerWidth <= 760) { rail.style.removeProperty('--cw'); return; }
        var cs = getComputedStyle(rail), gap = parseFloat(cs.columnGap) || 10, pl = parseFloat(cs.paddingLeft) || 0,
            vis = rail.clientWidth - pl, tab = window.innerWidth <= 1023, maxW = tab ? vis / 3.4 : (rail.clientHeight - 64) * 2 / 3, w;
        if (tab) { var k = Math.max(1, Math.ceil(vis / (maxW + gap) - .4)); w = (vis - k * gap) / (k + .4); }
        else {
          var n = Math.max(1, Math.floor((vis + gap) / (maxW + gap))), peek = (vis - n * (maxW + gap)) / maxW;
          w = peek < .2 ? (vis - n * gap) / (n + .2) : peek > .8 ? (vis - (n + 1) * gap) / (n + 1.2) : maxW;
        }
        rail.style.setProperty('--cw', Math.min(w, maxW).toFixed(1) + 'px');
      };
      size(); window.addEventListener('resize', size);
      var arrows = function(){
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      };
      var step = function(dir){
        var c = cards.filter(function(x){ return !x.classList.contains('off'); })[0] || rail.firstElementChild, gap = parseFloat(getComputedStyle(rail).columnGap) || 10;
        var w = (c ? c.getBoundingClientRect().width : 300) + gap, n = Math.max(1, Math.floor((rail.clientWidth - 40) / w));
        rail.scrollBy({ left: dir * n * w, behavior: calm ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function(){ step(-1); });
      if (next) next.addEventListener('click', function(){ step(1); });
      rail.addEventListener('scroll', function(){ window.requestAnimationFrame(arrows); }, { passive: true });
      window.addEventListener('resize', arrows);
      var apply = function(f, quiet){
        cards.forEach(function(c){ var s = c.hasAttribute('data-soon'), k = c.getAttribute('data-cat'); c.classList.toggle('off', f === 'all' ? s : k !== f); });
        tabs.forEach(function(t){ t.setAttribute('aria-pressed', String(t.getAttribute('data-f') === f)); });
        rail.scrollLeft = 0; arrows();
        var n = cards.filter(function(c){ return !c.classList.contains('off'); }).length, w = NAMES[f] || NAMES.all;
        if (live && !quiet) live.textContent = (mgHomeEn ? 'Showing ' : 'Mostrando ') + n + ' ' + (n === 1 ? w[0] : w[1]);
      };
      tabs.forEach(function(t){ t.addEventListener('click', function(){
        var f = t.getAttribute('data-f'); if (f === cur) return; cur = f;
        if (calm) apply(f); else { rail.classList.add('is-swap'); setTimeout(function(){ apply(f); rail.classList.remove('is-swap'); }, 200); }
      }); });
      apply('all', true);
      window.addEventListener('load', arrows);
    }

    /* ── talla rápida (móvil): el «+» de la foto abre una ventana con las tallas de esa prenda ── */
    var sh = $('[data-hm-sheet]');
    if (sh) {
      var sImg = $('[data-s-img]', sh), sNm = $('[data-s-nm]', sh), sPr = $('[data-s-pr]', sh), sSizes = $('[data-s-sizes]', sh), sAdd = $('[data-s-add]', sh), sFull = $('[data-s-full]', sh), sX = $('[data-s-x]', sh),
          pick = null, opener = null, SZ = { Small: 'S', Medium: 'M', Large: 'L', XLarge: 'XL', XXLarge: 'XXL' };
      var close = function(){ sh.classList.remove('on'); sh.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (opener) opener.focus(); };
      var open = function(card, btn){
        opener = btn; pick = null;
        var im = $('.im img', card);
        sImg.src = im ? (im.currentSrc || im.src) : ''; sNm.textContent = ($('.nm', card) || {}).textContent || '';
        sPr.innerHTML = ($('.pr', card) || {}).innerHTML || ''; sFull.href = card.getAttribute('href');
        sSizes.innerHTML = '';
        $$('.qa button', card).forEach(function(b){
          var full = (b.getAttribute('aria-label') || '').replace(/^(?:Añadir a la (?:bolsa|cesta)|Add to (?:bag|cart))\s*/i, ''), x = document.createElement('button');
          x.type = 'button'; x.textContent = SZ[full] || b.textContent.trim(); x.setAttribute('aria-pressed', 'false'); x.setAttribute('aria-label', (mgHomeEn ? 'Size ' : 'Talla ') + (SZ[full] || full) + (b.disabled ? (mgHomeEn ? ', sold out' : ', agotada') : ''));
          x.disabled = b.disabled; x.setAttribute('data-v', b.getAttribute('data-v'));
          x.addEventListener('click', function(){ pick = x.getAttribute('data-v'); $$('button', sSizes).forEach(function(y){ y.setAttribute('aria-pressed', String(y === x)); }); sAdd.disabled = false; sAdd.textContent = mgHomeEn ? 'Add to cart' : 'Añadir a la cesta'; });
          sSizes.appendChild(x);
        });
        sAdd.disabled = true; sAdd.textContent = mgHomeEn ? 'Choose a size' : 'Elige una talla';
        sh.classList.add('on'); sh.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
        setTimeout(function(){ var f = $('button:not(:disabled)', sSizes); if (f) f.focus(); }, 60);
      };
      document.addEventListener('click', function(e){
        var b = e.target.closest('[data-hm-qs]'); if (!b) return;
        e.preventDefault(); e.stopPropagation(); open(b.closest('.card'), b);
      }, true);
      sAdd.addEventListener('click', function(){
        if (!pick || !window.MG || !MG.add) return;
        sAdd.disabled = true; var id = Number(pick);
        close(); MG.add({ items: [{ id: id, quantity: 1 }] }).catch(function(err){ alert(err.message); });
      });
      sX.addEventListener('click', close);
      sh.addEventListener('click', function(e){ if (e.target === sh) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sh.classList.contains('on')) close(); });
    }

    /* ── vídeos de las secciones: solo se reproducen mientras se ven ── */
    var vids = $$('[data-hm-vid]');
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ var v = e.target; if (e.isIntersecting && !calm) play(v); else v.pause(); }); }, { threshold: .15 });
      vids.forEach(function(v){ vio.observe(v); });
    }
    if (calm) vids.forEach(function(v){ v.addEventListener('loadedmetadata', function(){ try { v.currentTime = 1.2; } catch(e){} }); });
  })();
  

})();
